import { useState, useEffect } from 'react'

// Reads the leveraged_etfs map (Atlas stock → its 2× single-stock ETFs) from
// /api/leveraged-etfs. Pass an `underlying` to fetch just one stock's funds
// (the TickerSheet "Leveraged" section); omit it for the full Leverage Desk.
//
// Returns { instruments, count, issuers, loading }. Each instrument:
//   { underlying, name, theme, etfs: [{ ticker, issuer, leverage, expense_ratio }] }
export function useLeveragedEtfs(underlying) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    const url = underlying
      ? `/api/leveraged-etfs?underlying=${encodeURIComponent(underlying)}`
      : '/api/leveraged-etfs'
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setData(d); setLoading(false) } })
      .catch(() => { if (!cancelled) { setData(null); setLoading(false) } })
    return () => { cancelled = true }
  }, [underlying])

  return {
    instruments: data?.instruments ?? [],
    sectors: data?.sectors ?? [],
    count: data?.count ?? 0,
    issuers: data?.issuers ?? 0,
    loading,
  }
}
